module.exports = "/images/aisles.svg";